<template>
    <div>
        <template v-if="loadingCourseDiscussion">
            <div class="div__loading">
                <loader />
            </div>
        </template>
        <template v-else>
            <div class="module__wrapper thread">
                <div class="forum__heading">
                    <div class="forum__left">
                        <h4 class="forum__title">Discussions</h4>
                    </div>
                    <div class="d-flex align-items-center mb-heading">
                        <template v-if="online_class_id" >

                            <router-link
                                    :to="{ name: 'create-course-lesson-discussion'}"
                                    class="text-underline text-black-70 ml-auto"
                                    exact>Ask a
                                Question
                            </router-link>
                        </template>
                        <template v-else>

                            <router-link
                                    :to="{ name: 'create-course-discussion'}"
                                    class="text-underline text-black-70 ml-auto"
                                    exact>Ask a
                                Question
                            </router-link>
                        </template>


                    </div>
                    <template v-if="joinedCourse">
                        <!--<router-link-->
                            <!--:to="{ name: 'create-course-discussion'}"-->
                            <!--class="btn btn__primary btn__primary&#45;&#45;link"-->
                            <!--exact>Create New Course Discussion-->
                        <!--</router-link>-->
                    </template>
                </div>
                <div class="forum__body">
                    <template v-if="courseDiscussion && courseDiscussion.length > 0">
                        <div
                            v-for="item in courseDiscussion"
                            :key="item.id"
                            class="forum__item section__row">
							<img v-if="item.user.avatar" class="post__img" :src="item.user.avatar" alt="">
                            <img v-else class="post__img" src="../../assets/img/profile.jpg" alt="">
                            <div class="thread__body">
                                <router-link
                                    :to="{
                                        name: 'discussion-page',
                                        params: { discussionId: item.id, id: item.online_class_id }
                                    }"
                                >
                                    <h6 class="bold">{{ item.title }}</h6>
                                </router-link>
                                <span class="meta">{{ item.created_at | date }}</span>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="item__row thread__item">
                            <div class="thread__body">
                                <h6 class="bold">No Course Discussion</h6>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { getCourseDiscussion } from '../../utils/api/course';
import Loader from '../../components/Loader';

export default {
	name: 'CourseDiscussion',
	props: {
		joinedCourse: [Boolean, String]
	},
	data() {
		return {
			courseDiscussion: [],
			courseDiscussionLoaded: false,
			loadingCourseDiscussion: true,
            online_class_id : this.$route.params.onlineClassId
		};
	},
	methods: {
		getCourseDiscussion() {
			getCourseDiscussion( this.$route.params.onlineClassId || this.$route.params.id)
				.then((response) => {
					if (response.status === 200) {
						this.courseDiscussion = response.data.data;
						this.courseDiscussionLoaded = true;
						return true;
					}
					this.courseDiscussionLoaded = false;
					return false;
				}).catch((error) => {
					this.courseDiscussionLoaded = false;
				}).finally(() => {
					this.loadingCourseDiscussion = false;
				});
		}
	},
	mounted() {
		this.getCourseDiscussion();
	},
	components: {
		Loader
	},
	filters: {
		date(value) {
			return moment(value).fromNow();
		}
	},
	watch: {
		joinedCourse() {
			return this.joinedCourse;
		}
	}
};
</script>

<style scoped>
.div__loading {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}
</style>
